<template>
    <cadastro-simples-list
        endpoint="tipo-ata"
        rota-base="/admin/tipo-ata"
        titulo="TIPOS DE ATA"
        titulo-singular="Tipo de Ata"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
